package ai.wagemix.pages

import ai.wagemix.di.koin
import ai.wagemix.env
import ai.wagemix.logic.WMNavigationRequest
import ai.wagemix.navigate
import ai.wagemix.siteStrings
import ai.wagemix.web.screens.pricing.WMDefaultPricingWebViewModel
import ai.wagemix.web.screens.pricing.WMPricingScreen
import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import org.koin.core.parameter.parametersOf

@Page
@Layout(".components.layouts.MarketingLayout")
@Composable
fun PricingPage(ctx: PageContext) {
    WMPricingScreen(
        createViewModel = {
            koin.get<WMDefaultPricingWebViewModel> {
                parametersOf({ request: WMNavigationRequest -> ctx.navigate(request) })
            }
        },
        strings = siteStrings,
    )
}
